import { type Parser } from "../../base_classes/dto_parser.d";

const parsers: Parser[] = [
  {
    field: "desiredDeliveryDate",
    parser: "date",
  },
  {
    field: "promisedDeliveryDate",
    parser: "date",
  },
];

export default parsers;
